export const environment = {
  production: false,
  name: 'local dev',
  keycloak: {
    url: 'https://keycloak-de.phxcloud.eu',
    realm: 'contract-portal',
    clientId: 'contract-portal'
  },
  apiRestUrl: 'https://dev-contracts.phoenix-apothekenportal.de',
}
